import { useState, useEffect, useCallback } from "react";
import { useSession } from "@clerk/clerk-react";

/* Her credit balance, as the server reads it (api/_lib/credits.js balanceOf —
   the SAME reading the gate stops on, so the meter can never disagree with
   it). Asked of /api/chat with mode "credits": free — no model call, no usage
   row. Read on mount; `refresh` after anything that spends.

   null while loading, and stays null when credits are not switched on yet or
   she is the admin — every reader treats null as "show nothing".          */
export function useCredits() {
  const { session } = useSession();
  const [credits, setCredits] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const token = await session?.getToken();
      if (!token) return;
      const res = await fetch("/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ mode: "credits" }),
      });
      if (!res.ok) return;
      const data = await res.json();
      setCredits(data && data.on && !data.admin ? data : null);
    } catch {
      /* The meter is a convenience; Brill works without it. */
    }
  }, [session]);

  useEffect(() => { refresh(); }, [refresh]);
  return { credits, refresh };
}

/* "23 October" — the day the meter starts stopping people. */
export function creditsDate(iso) {
  if (!iso) return "";
  const d = new Date(`${iso}T00:00:00Z`);
  return d.toLocaleDateString(undefined, { day: "numeric", month: "long", timeZone: "UTC" });
}
